function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var accessControlDomainTest = function(domain) {
    return /(cloud\.tencent\.com)|(cloud\.tencent\.cn)|(cloud\.tencent\.com\.cn)|(tencentcloud.com)$/.test(domain);
};
/**
 * 获取客户端IP，此IP无法伪造
 * PS.此IP为直连服务器的IP，亦即，如果用户经过代理机，则获取到的为代理机的IP
 *
 * @param req
 */ export var getUserRemoteIP = function(req) {
    var remoteIP = req.headers['x-ttcdn-real-ip'] // kairong:门神提出来，使用CLB接入的域名他们只能通过x-ttcdn-real-ip进行打击
     || req.headers['x-ecdn-real-ip'] // 接入ecdn后，这里才是用户真实IP
     || req.headers['x-real-ip']; // 未接入ecdn时的用户ip获取方式；或者运维配置将ecdn的ip写到了这里
    if (!remoteIP) {
        var ipList = (req.headers['x-forwarded-for'] || '').replace(/\s/g, '').split(',');
        var ref;
        ref = _slicedToArray(ipList, 1), remoteIP = ref[0], ref; // 链路中的第一个ip。
    }
    remoteIP = remoteIP || req.connection.remoteAddress || req.ip;
    return remoteIP || '127.0.0.1';
};
export var corsPass = function(url) {
    return url.startsWith('/api/mid/render/') || url.startsWith('/api/mid/common/');
};
/**
 * 设置跨域处理
 */ export function setCors(req, res) {
    if (corsPass(req.url) && req.headers.origin && accessControlDomainTest(req.headers.origin)) {
        res.setHeader('Access-Control-Allow-Credentials', 'true');
        res.setHeader('Access-Control-Allow-Origin', req.headers.origin); // req.headers.origin
        res.setHeader('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS');
        res.setHeader('Access-Control-Allow-Headers', 'Content-Type, Content-Length, Authorization, Accept, X-Requested-With, x-request-id');
        res.setHeader('Access-Control-Max-Age', '3600');
    }
}
